export default __webpack_public_path__ + "static/media/congrats.671fdc76.svg";